const nav_links = document.querySelectorAll<HTMLAnchorElement>(".nav-link");

const section_map = new Map<string, HTMLAnchorElement>();
for (const link of Array.from(nav_links)) {
  const id = link.getAttribute("href")?.slice(1);
  if (id) section_map.set(id, link);
}

function set_active(id: string) {
  for (const [, link] of section_map) link.classList.remove("is-active");
  section_map.get(id)?.classList.add("is-active");
}

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) set_active(entry.target.id);
    }
  },
  { rootMargin: "-40% 0px -55% 0px", threshold: 0 },
);

for (const id of section_map.keys()) {
  const el = document.getElementById(id);
  if (el) observer.observe(el);
}
